import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';

import {
  PageLogin,
  PagePwdReset,
  PagePwdResetMail,
  PageRegister,
  PageVerifyUser,
  PagePrivacyPolicy,
} from './pages';
import PageNotFound from '~/commons/components/PageNotFound.jsx';
import CookiePolicy from '~/commons/components/CookiePolicy.jsx';

const Auth = () => (
  <div className="d-flex content-100">
    <div className="my-auto w-100">
      <Router>
        <Switch>
          <Route path="/auth/pwd-recovery">
            <PagePwdResetMail />
          </Route>
          <Route path="/auth/pwd-expired">
            <PagePwdResetMail expired />
          </Route>
          <Route path="/auth/pwd-reset">
            <PagePwdReset />
          </Route>
          <Route path="/auth/register">
            <PageRegister />
          </Route>
          <Route path="/auth/verify">
            <PageVerifyUser />
          </Route>
          <Route path="/auth/privacy-policy">
            <PagePrivacyPolicy />
          </Route>
          <Route exact path="/auth/">
            <PageLogin />
          </Route>
          <Route path="*">
            <PageNotFound />
          </Route>
        </Switch>
        <CookiePolicy />
      </Router>
    </div>
  </div>
);

export default Auth;
